import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import apiHandler from "../common/api";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { ChevronUp, RotateCcw } from "react-feather";
import { setToogleHeader, setUserData } from "../../core/redux/action";
import {
  // dateFormat,
  deleteCookie,
  getCookie,
  setCookie,
} from "../common/common";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { all_routes } from "../../Router/all_routes";
import { portalUrl } from "../../config";
import moment from "moment";

const BusinessSubscription = () => {
  const user_data = useSelector((state) => state.user_data);
  const data = useSelector((state) => state.toggle_header);
  const params = new URLSearchParams(window.location.search);
  const id = params.get("id");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [productlist, setProductlist] = useState([]);
  const [durationPlans, setDurationPlans] = useState([]);
  const [deletes] = useState(false); // setdelete
  const [hasPreviousSubscription, setHasPreviousSubscription] = useState(false);



  console.log(data, "check datat8489748")
  console.log(user_data, "user_data 78787");
  //   const [stripeSesstionId, setStripeSesstionId] = useState("");

  const MySwal = withReactContent(Swal);

  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );
  const renderCollapseTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Collapse
    </Tooltip>
  );

  const prodcutDataListApi = async () => {
    const response = await apiHandler({
      method: "GET",
      route: `Business/subscriptionplans`,
    });
    if (response.ResponseCode === "SUCCESS") {
      console.log(response, "data");
      setProductlist(
        id > 0
          ? response.ResponseData.filter((el) => el.templateId == id)
          : response.ResponseData
      );
    } else {
      console.log(response, "data");
    }
  };
  const fetchSubscriptionPlanDuration = async () => {
    const multipleTablesData = await apiHandler({
      method: "GET",
      route: "Business/getMultipleTablesData",
      payload: { tableNames: "subscriptionPlanDuration" }, // make sure dont add space in the string and its correct.
    });
    if (multipleTablesData.ResponseCode === "SUCCESS") {
      if (
        Array.isArray(multipleTablesData.ResponseData[0]) &&
        multipleTablesData.ResponseData[0].length > 0
      ) {
        const durationData = multipleTablesData.ResponseData[0]
          .filter((el) => el.isDeleted !== 1)
          .map((el) => ({
            id: el.id,
            label: el.label || "",
            value: el.value || "",
          }));
        setDurationPlans(durationData);
      } else {
        console.warn("No valid subscription plan duration data found.");
      }
    } else {
      console.log(multipleTablesData, "data");
    }
  };

  console.log(productlist, "productlist");
  console.log(durationPlans, "durationPlans");

  const checkPreviousSubscription = async () => {
    if (!user_data?.businessId) return;
    try {
      const response = await apiHandler({
        method: "GET",
        route: `Business/businessTransactionList?businessId=${user_data.businessId}`,
      });
      if (response.ResponseCode === "SUCCESS" && Array.isArray(response.ResponseData)) {
        const hasSub = response.ResponseData.some(tx => tx.stripeSubscriptionId);
        if (hasSub) {
          setHasPreviousSubscription(true);
        }
      }
    } catch (error) {
      console.error("Error checking subscription history:", error);
    }
  };

  useEffect(() => {
    if (user_data?.planStripeSubscriptionId) {
      setHasPreviousSubscription(true);
    } else {
      checkPreviousSubscription();
    }
  }, [user_data]);

  useEffect(() => {
    prodcutDataListApi();
    fetchSubscriptionPlanDuration();
  }, [deletes]);

  // Group plans by templateSubscriptionName
  const groupedPlans = productlist.reduce((acc, plan) => {
    if (!acc[plan.templateSubscriptionName]) {
      acc[plan.templateSubscriptionName] = [];
    }
    acc[plan.templateSubscriptionName].push(plan);
    return acc;
  }, {});

  console.log(groupedPlans, "groupedPlans");

  const handleSubscribe = async (plane, durationType, durationValue) => {
    console.log(plane, durationValue, "data");
    try {
      const response = await apiHandler({
        method: "POST",
        route: "stripe/create-checkout-session",
        payload: {
          stripeCustomerId: user_data?.stripeCustomerId || "",
          customerEmail: user_data?.email, // Get from logged-in user
          priceId: plane?.stripePriceId, //"price_1RKFwKPQ4Q3XALvt1LwdKBku", // Replace with your Stripe Price ID
          metadata: {
            CustomerName: user_data?.fullName,
            businessId: user_data?.businessId,
            businessUniqueName: user_data?.businessUniqueName,
            phoneNumber: user_data?.phoneNumber,
            email: user_data?.email,
            stripePriceId: plane?.stripePriceId,
            templateId: plane?.templateId,
            priceId: plane?.id,
            templateSubscriptionName: plane?.templateSubscriptionName,
            templateSubscriptionType: durationType,
          },
          line_items: [
            {
              price: plane?.stripePriceId,
              // quantity: durationValue,
              quantity: 1,
            },
          ],
          mode: "subscription",
          // mode: plane?.isDefaultAutoPaid == 1 ? "subscription" : "payment",
          success_url: `${portalUrl}/businesssubscription?status=true`,
          cancel_url: `${portalUrl}/businesssubscription?status=false`,
          // isDiscountedPlan: plane?.discountPrice ? true : false,
          // isDiscountedPlan: (plane?.durationInDays > 30 && !hasPreviousSubscription) ? true : false,
          isDiscountedPlan: (!hasPreviousSubscription) ? true : false,
        },
      });

      console.log(response, "checkoutsession check");
      setCookie("SesstionId", response.id);
      //   setStripeSesstionId(response.id || "")

      window.location.href = response.url;
    } catch (error) {
      console.error("Subscription error", error);
    }
  };

  useEffect(() => {
    const sessionId = getCookie("SesstionId") || null;
    const urlParams = new URLSearchParams(window.location.search);
    const status = urlParams.get("status");

    console.log(sessionId, status, "sessionId");

    if ((status === "true" || status === "false") && sessionId) {
      const fulfillCheckout = async () => {
        try {
          MySwal.fire({
            title: "Processing Payment...",
            text: "Please wait while we process your payment.",
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            },
          });

          const response = await apiHandler({
            method: "POST",
            route: "stripe/fulfillcheckout",
            payload: {
              sessionId: sessionId,
              module: "business",
            },
          });

          Swal.close(); // Close the loading modal

          if (response.responseStatus === "SUCCESS" && response.paymentStatus == "paid") {


            const SubscriptionResponse = await apiHandler({ method: "GET", route: "Business/getSubscriptionDetail", payload: { BusinessID: user_data?.businessId } });

            const UsertSubscription = await apiHandler({ method: "POST", route: "Business/upsertBussinessMassage", payload: { BusinessID: user_data?.businessId, TemplateID: SubscriptionResponse?.ResponseData[0][0]?.subscriptionPriceId, } });



            MySwal.fire({
              title: "Payment Status!",
              text: `Your payment is successfully paid. Your Subscription Id: ${response.subscription}. Invoice Id: ${response.invoice}`,
              icon: "success",
              confirmButtonText: "OK",
              customClass: {
                confirmButton: "btn btn-success",
              },
            }).then(() => {
              const userObject = {
                ...user_data,
                planSubscriptionPriceId: response?.metadata?.priceId,
                planSubscriptionTemplateId: response?.metadata?.templateId,
                planPlanName: response?.metadata?.templateSubscriptionType,
                planSubscriptionName:
                  response?.metadata?.templateSubscriptionName,
                planExpireDate: response.planExpireDate,
                planIsCancel: 0,
                planStripeSubscriptionId: response.subscription,
              };
              dispatch(setUserData(userObject));
              setCookie("u", userObject, { expires: 1 });

              // Show popup based on UsertSubscription result
              if (UsertSubscription && (UsertSubscription?.ResponseCode === "SUCCESS" || UsertSubscription?.success === true || UsertSubscription?.responseStatus === "SUCCESS")) {
                console.log("User subscription updated successfully.");
              }
            });
          } else {
            MySwal.fire({
              title: "Payment Status!",
              text: `Your payment has failed!`,
              icon: "error",
              confirmButtonText: "OK",
              customClass: {
                confirmButton: "btn btn-danger",
              },
            });
          }
          navigate(all_routes?.businessSubscription);
          deleteCookie("SesstionId");
          console.log(response, "response");
        } catch (error) {
          Swal.close(); // Close the loading modal in case of error
          console.error("Error fulfilling checkout:", error);
          MySwal.fire({
            title: "Error",
            text: "An error occurred while processing your payment. Please try again.",
            icon: "error",
            confirmButtonText: "OK",
            customClass: {
              confirmButton: "btn btn-danger",
            },
          });
        }
      };

      fulfillCheckout();
    }
  }, []);

  const handleCancelSubscriptionAlert = () => {
    MySwal.fire({
      title: "Are you sure?",
      text: "Do you really want to cancel your subscription? This action cannot be undone.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, cancel it!",
      cancelButtonText: "No, keep it",
      cancelButtonColor: "#ff0000",
    }).then((result) => {
      if (result.isConfirmed) {
        handleCancelSubscription();
      }
    });
  };

  const handleCancelSubscription = async () => {
    try {
      MySwal.fire({
        title: "Cancelling Subscription...",
        text: "Please wait while we process your cancellation.",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const response = await apiHandler({
        method: "POST",
        route: "stripe/cancelSubscription",
        payload: {
          subscriptionId: user_data?.planStripeSubscriptionId,
          businessId: user_data?.businessId,
          businessUniqueName: user_data?.businessUniqueName,
          email: user_data?.email,
          phoneNumber: user_data?.phoneNumber,
          planExpireDate: user_data?.planExpireDate,
          planSubscriptionName: user_data?.planSubscriptionName,
          // grace period added 15 days
          cancel_at: user_data?.planExpireDate
            ? new Date(
              new Date(user_data.planExpireDate).getTime() + 15 * 24 * 60 * 60 * 1000
            ).toISOString()
            : null,
        },
      });

      Swal.close();

      if (response?.success) {
        const cancelDate = response.cancel_at
          ? new Date(response.cancel_at).toLocaleDateString()
          : null;

        MySwal.fire({
          title: "Cancellation Scheduled",
          text: cancelDate
            ? `Your subscription will be cancelled on ${cancelDate}.`
            : "Your subscription will be cancelled at the end of the billing period.",
          icon: "success",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "btn btn-success",
          },
        }).then(() => {
          const userObject = {
            ...user_data,
            planIsCancel: 1,
          };
          dispatch(setUserData(userObject));
          setCookie("u", userObject, { expires: 1 });
          prodcutDataListApi(); // Refresh product list
          fetchSubscriptionPlanDuration(); // Refresh plan status
        });
      } else {
        MySwal.fire({
          title: "Error",
          text:
            response?.message ||
            response?.ResponseMessage ||
            "Failed to cancel subscription.",
          icon: "error",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "btn btn-danger",
          },
        });
      }
    } catch (error) {
      Swal.close();
      MySwal.fire({
        title: "Error",
        text: "An error occurred while cancelling your subscription.",
        icon: "error",
        confirmButtonText: "OK",
        customClass: {
          confirmButton: "btn btn-danger",
        },
      });
      console.error("Cancel subscription error", error);
    }
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h3 className="text-color-70">Subscription Plans</h3>
              <h6 className="text-color-40">Manage your Subscription Plans</h6>
            </div>
          </div>
          <ul className="table-top-head">
            <li>
              <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
                <Link
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  onClick={() => {
                    prodcutDataListApi();
                    fetchSubscriptionPlanDuration();
                  }}
                >
                  <RotateCcw />
                </Link>
              </OverlayTrigger>
            </li>
            <li>
              <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                <Link
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  id="collapse-header"
                  className={data ? "active" : ""}
                  onClick={(e) => {
                    e.preventDefault();
                    dispatch(setToogleHeader(!data));
                  }}
                >
                  <ChevronUp />
                </Link>
              </OverlayTrigger>
            </li>
          </ul>
        </div>

        <div className="card">
          <div className="card-body p-4 d-flex flex-wrap justify-content-between align-items-center">
            <div className="d-flex flex-column">
              <h4>
                <span className="fw-bold text-color-70">Current plan: </span>
                <span>
                  {user_data?.planSubscriptionTemplateId == 4
                    ? "Free Trial"
                    : user_data?.user_data?.planSubscriptionName}
                </span>
              </h4>
              <div className="d-flex gap-1">
                <span className="fw-bold">Plan Subscription ID : </span>
                <span>
                  {user_data?.planSubscriptionTemplateId == 4
                    ? "Free"
                    : user_data?.planStripeSubscriptionId}
                </span>
              </div>

              <div className="d-flex gap-1">
                <span className="fw-bold">Plan Type : </span>
                <span>
                  {user_data?.planSubscriptionTemplateId == 4
                    ? "Days"
                    : user_data?.planPlanName}
                </span>
              </div>
              <div className="d-flex gap-1">
                <span className="fw-bold">Plan Expire : </span>
                <span>
                  {
                    user_data?.planStripeSubscriptionId && user_data?.planExpireDate
                      ? (() => {
                        const expireDate = moment(
                          user_data.planExpireDate,
                          "YYYY-MM-DD HH:mm:ss",
                          true // strict parsing
                        );

                        if (!expireDate.isValid()) {
                          return "Not Set";
                        }

                        const isExpired = expireDate.isBefore(moment());

                        return isExpired
                          ? "Expired"
                          : expireDate.format("DD/MM/YYYY");
                      })()
                      : ""
                  }
                </span>
              </div>
            </div>
            {user_data?.planStripeSubscriptionId && (
              <div>
                {/* Hide the button if plan is expired */}
                {
                // user_data?.planIsCancel === 1 ? (
                //   <span className="text-danger fw-bold">
                //     Your plan cancellation is done
                //   </span>
                // ) : (
                  user_data?.planExpireDate &&
                  (() => {
                    const expireDate = moment(
                      user_data.planExpireDate,
                      "DD/MM/YYYY HH:mm:ss"
                    );
                    const isExpired = expireDate.isBefore(moment());
                    return !isExpired ? (
                      <button
                        className="btn btn-primary btn-md me-2"
                        onClick={() => handleCancelSubscriptionAlert()}
                      >
                        cancel Subscription
                      </button>
                    ) : null;
                  })()
                // )
                }
              </div>
            )}
          </div>
        </div>

        <div className="card">
          <div className="card-body pb-1">
            {Object.entries(groupedPlans).map(([templateName, planGroup]) => (
              <div key={templateName} className="mt-3">
                <h4 className="mb-4">{templateName}</h4>
                <div className="row justify-content-start">
                  {durationPlans.map((duration, index) => {
                    const matchedPlan = planGroup.find(
                      (p) => p.durationId === duration.id
                    );
                    return matchedPlan?.isActive === 1 ? (
                      <div
                        className="col-xxl-3 col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12"
                        key={duration.id}
                      >
                        <div
                          className={`card ${index === 1 && "pricing-active-primary"
                            } Position-relative mb-3`}
                        >
                          {/* {index === 1 && (
                            <span className="badge bg-primary badge-top">
                              Recommended
                            </span>
                          )}
                          {user_data?.planSubscriptionPriceId ==
                            matchedPlan.id && (
                              <span className="badge bg-blue badge-top">
                                Active Now (Exp on:{" "}
                                {dateFormat(user_data?.planExpireDate)})
                              </span>
                            )} */}

                          {(() => {
                            const isActivePlan =
                              user_data?.planSubscriptionPriceId == matchedPlan?.id;

                            return (
                              <>
                                {/* Recommended Badge */}
                                {index === 1 && !isActivePlan && (
                                  <span className="badge bg-primary badge-top">
                                    Recommended
                                  </span>
                                )}

                                {/* Active Badge */}
                                {isActivePlan && (
                                  <span className="badge bg-primary badge-top">
                                    Active
                                  </span>
                                )}
                              </>
                            );
                          })()}

                          <div className="card-body">
                            {matchedPlan && (() => {
                              // Only freeMessages varies by duration; name/price come from DB
                              const freeMessagesMap = {
                                30: 100,
                                90: 200,
                                180: 300,
                                365: 400,
                              };
                              const freeMessages2ndMonth = freeMessagesMap[matchedPlan.durationInDays];

                              return (
                                <>
                                  {/* Plan name — dynamic from DB */}
                                  <p style={{ fontSize: "18px" }} className="fw-bold mb-1">
                                    {duration.label} ({templateName})
                                  </p>

                                  {/* Price — dynamic from DB */}
                                  {/* <div className="d-flex align-items-center mb-2">
                                    <h4 className="d-flex gap-1 align-items-center mb-0">
                                      {matchedPlan.discountPrice && (
                                        <span className="mr-1">
                                          ${matchedPlan.discountPrice}
                                        </span>
                                      )}
                                      {matchedPlan.price && (
                                        <span
                                          style={{
                                            textDecoration: "line-through",
                                            color: "#999",
                                            fontSize: "16px",
                                            marginTop: "3px",
                                          }}
                                        >
                                          ${matchedPlan.price}
                                        </span>
                                      )}
                                    </h4>
                                    <span className="d-inline-flex ms-1">
                                      Per Month
                                    </span>
                                  </div> */}
                                  {/* Price — dynamic from DB */}
                                  <div className="d-flex align-items-center mb-2">
                                    <h4 className="d-flex gap-1 align-items-center mb-0">
                                      {matchedPlan.discountPrice ? (
                                        <>
                                          <span className="mr-1">
                                            ${matchedPlan.discountPrice}
                                          </span>
                                          <span
                                            style={{
                                              textDecoration: "line-through",
                                              color: "#999",
                                              fontSize: "16px",
                                              marginTop: "3px",
                                            }}
                                          >
                                            ${matchedPlan.price}
                                          </span>
                                        </>
                                      ) : (
                                        <span>${matchedPlan.price}</span>
                                      )}
                                    </h4>

                                    <span className="d-inline-flex ms-1">Per Month</span>
                                  </div>

                                  {/* Duration in days — dynamic from DB */}
                                  {/* {matchedPlan.durationInDays > 30 && !hasPreviousSubscription ? (
                                  <p className="fw-bold mb-3">
                                    30 Days Free • {matchedPlan.durationInDays} days for ${((matchedPlan?.durationInDays / 30)?.toFixed(0) * matchedPlan.discountPrice)?.toFixed(2)}
                                  </p>
                                  ) : matchedPlan.durationInDays > 30 && hasPreviousSubscription ? (
                                  <p className="fw-bold mb-3">
                                    {matchedPlan.durationInDays} days for ${((matchedPlan?.durationInDays / 30)?.toFixed(0) * matchedPlan.discountPrice)?.toFixed(2)}
                                  </p>
                                  ) : (
                                  <p className="fw-bold mb-3">
                                    {matchedPlan.durationInDays} days for ${matchedPlan.price}
                                  </p>
                                  )} */}

                                  {!hasPreviousSubscription ? (
                                    <p className="fw-bold mb-3">
                                      30 Days Free • {matchedPlan.durationInDays} days for $
                                      {(
                                        (matchedPlan.durationInDays / 30).toFixed(0) *
                                        (matchedPlan.discountPrice || matchedPlan.price)
                                      ).toFixed(2)}
                                    </p>
                                  ) : (
                                    <p className="fw-bold mb-3">
                                      {matchedPlan.durationInDays} days for $
                                      {(
                                        (matchedPlan.durationInDays / 30).toFixed(0) *
                                        (matchedPlan.discountPrice || matchedPlan.price)
                                      ).toFixed(2)}
                                    </p>
                                  )}

                                  {/* Free Trial badge */}
                                  {!hasPreviousSubscription && (
                                    <span className="badge bg-success mb-3 d-inline-block" style={{ fontSize: "12px" }}>
                                      One Month Free Trial
                                    </span>
                                  )}

                                  {/* Subscribe button */}
                                  <div
                                    onClick={() =>
                                      handleSubscribe(matchedPlan, duration.label, duration.value)
                                    }
                                    className="btn btn-primary w-100 mb-3"
                                  >
                                    Subscribe Now
                                  </div>

                                  {/* Features heading */}
                                  <p className="fw-bold mb-2" style={{ fontSize: "15px" }}>
                                    Includes
                                  </p>

                                  {/* Static feature list */}
                                  <ul className="list-unstyled mb-2">
                                    {[
                                      "Unlimited team members",
                                      "100 free messages for first month**",
                                      "100 free marketing emails",
                                      "Phone, email and chat support",
                                      "Booking notifications",
                                    ].map((feature) => (
                                      <li
                                        className="d-flex align-items-start mb-2"
                                        key={feature}
                                      >
                                        <span
                                          style={{
                                            backgroundColor: "#7a1a86",
                                            borderRadius: "50%",
                                            marginRight: "10px",
                                            marginTop: "4px",
                                            flexShrink: 0,
                                            position: "relative",
                                            display: "inline-block",
                                            width: "16px",
                                            height: "16px",
                                          }}
                                        >
                                          <span
                                            style={{
                                              position: "absolute",
                                              top: "50%",
                                              left: "50%",
                                              transform: "translate(-50%, -50%)",
                                              width: "4px",
                                              height: "4px",
                                              backgroundColor: "white",
                                              borderRadius: "50%",
                                            }}
                                          ></span>
                                        </span>
                                        <span style={{ fontSize: "13px" }}>{feature}</span>
                                      </li>
                                    ))}
                                  </ul>

                                  {/* Footnotes */}
                                  <div
                                    style={{
                                      borderTop: "1px solid #eee",
                                      paddingTop: "10px",
                                      fontSize: "12px",
                                      color: "#666",
                                    }}
                                  >
                                    {freeMessages2ndMonth && (
                                      <p className="mb-1">
                                        <strong>**</strong>
                                        {freeMessages2ndMonth} Free messages from second month if number of bookings criteria are met
                                      </p>
                                    )}
                                    <p className="mb-0">
                                      <strong>*</strong>0.95 cents per booking charge
                                    </p>
                                  </div>
                                </>
                              );
                            })()}
                          </div>
                        </div>
                      </div>
                    ) : (
                      ""
                    );
                  })}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusinessSubscription;
